const styles = (theme) => ({
  icon: {
    width: 20,
    height: 20,
  },

  avatar: {
    background: theme.color.black_11,
    fontSize: 16,
  },

  link: {
    fontSize: '16px',
    color: theme.color.black_11,
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  menuItemIcon: {
    minWidth: '30px',
    marginTop: 12,
    '& path': {
      fill: 'inherit',
    },
  },
});

export default styles;
